import React from 'react'
import { pluralize } from '@/util/stringHelpers'
import {
  ArcadeConvertedItem,
  ArcadeConvertedItems
} from '@/api/resources/shared/action'
import { Icon, PreviewMedia, Separator } from '@/components'
import { numberWithCommas } from '@/util/numberHelpers'
import CircleIconLink from '@/components/CircleIconLink'
import { MEDIA_SIZES } from '@/constants'

const ConvertedItem = ({
  item: { name, media, mints, points }
}: {
  item: ArcadeConvertedItem
}) => {
  const assetMedia = media[0]

  return (
    <div className="flex items-center mt-2">
      <PreviewMedia
        className="w-5 h-5 object-contain mr-[12px]"
        size={MEDIA_SIZES.TINY}
        media={assetMedia}
      />
      <div className="body-sm flex-1">
        <div>{name}</div>
        <div>{mints.map(m => `#${m}`).join(', ')}</div>
      </div>
      <div className="flex items-center gap-[4px] ml-1">
        <Icon name="arcade" className="h-2" />
        <div>{numberWithCommas(points)}</div>
      </div>
    </div>
  )
}

export const ConvertedItems = ({ items }: { items: ArcadeConvertedItems }) => {
  const { points, assets, tx_urls } = items
  const txnUrl = tx_urls[0]

  return (
    <>
      <div className="h5">{pluralize('Converted Item', items.count)}</div>
      {Object.values(assets).map(item => (
        <ConvertedItem key={item.data_id} item={item} />
      ))}
      <Separator className="my-3" />
      <div className="flex items-center justify-between">
        <div className="h5">TOTAL</div>
        <div className="text-lg flex items-center gap-1 font-bold">
          <Icon name="arcade" className="h-3" />
          <div>{numberWithCommas(points)}</div>
        </div>
      </div>
      <Separator className="my-3" />
      <div className="flex items-center justify-between">
        <div className="h7">View On Blockchain</div>
        {!!txnUrl && (
          <CircleIconLink
            name="blockchainV2"
            url={txnUrl}
            className="h-4 w-4"
            iconClassName="h-[20px] w-[20px]"
          />
        )}
      </div>
    </>
  )
}
